import Utils from '../../utils/Utils';
import { AAF_CONTENT_IS_TV } from '../constants';
import PlayerHelper from './PlayerHelper';
import { TPA_APA_DEFAULT_KEY } from './ThirdPartyAppsDefaultApaKey';
import Translator from 'src/requests/apa/Translator';
import Asset from 'src/requests/apa/Asset';
import DeviceStorage from 'src/components/DeviceStorage/DeviceStorage';
import store from '../../store';
import { playFullMedia } from '../../actions/playmedia';
import TvChannelUtil from 'src/utils/TvChannelUtil';
import logger from 'src/utils/logger/logger';

export const LIVE_PLAY_FROM_EPG = 'epg';
export const LIVE_PLAY_FROM_HOME = 'home';
export const LIVE_PLAY_FROM_MOSAIC = 'mosaic';
export const TPA_APA_KEY_NAME = 'third_party_epg_apps';

export const TPA_WAS_FIRED = 'a_tpa_app_was_fired';

export const ThirdPartyEpgHelper = (
    function () {
        let AAF_TPA_STATE = null;

        const thirdPartyapps = new Set();

        let fireTPA_timeout_milliseconds = 200;
        let fireTPA_timeout_id = null;

        const fireTV_timeout_milliseconds = 1.5 * 1000; // 1.5 segundos y a partir de aquí tunear

        const getApaKey = function () {
            const tpa = Utils.getApaMetadataKey(TPA_APA_KEY_NAME, TPA_APA_DEFAULT_KEY);
            // console.log('[TPA] ThirdPartyEpgHelper::getApaKey metadata key: ', tpa);

            return tpa;
        };

        const getTPA = function (key, from = LIVE_PLAY_FROM_EPG) {
            // console.log('[TPA] ThirdPartyEpgHelper::getTPA enter (key, from):', key, from);
            let TPA = null;
            const apaKey = getApaKey();
            if (Utils.isNotNullOrNotUndefined(apaKey[key])) {
                const TPAApp = apaKey[key];
                if (Utils.isNotNullOrNotUndefined(TPAApp[from])) {
                    TPA = TPAApp[from];
                }
            }
            // console.log('[TPA] ThirdPartyEpgHelper::getTPA TPA to return:', TPA, '    ************');

            return TPA;
        };

        const setAAFTPAState = function(state) {
            AAF_TPA_STATE = state;
        };

        const getAAFTPAState = function() {
            return AAF_TPA_STATE;
        };

        const isTpaKeyUp = function(TPA) {
            const  defaultvalue = TPA && TPA.package && typeof TPA.package === 'string' && (TPA.package.indexOf('netflix') !== -1 || TPA.package.indexOf('amazon') !== -1);
            if(TPA && (typeof TPA === 'object') && TPA.hasOwnProperty('tpakeyUp')){
                return TPA.tpakeyUp;
            }else{
                return defaultvalue;
            }
        }

        const fireTPA = function (TPA, playerOptions, successCallBack) {
            logger.debug('[TPA] ThirdPartyEpgHelper::fireTPA, enter');
            if(fireTPA_timeout_id) return;
            fireTPA_timeout_id = setTimeout(function() {
                clearTimeout(fireTPA_timeout_id);
                fireTPA_timeout_id = null;

                if(Utils.isObject(window.AndroidExternalAppInterface) && Utils.isFunction(window.AndroidExternalAppInterface.launchExternalApp)) {
                    logger.debug('[TPA] ThirdPartyEpgHelper::fireTPA, notify android, TPA', TPA, '    ************');
                    const res = window.AndroidExternalAppInterface.launchExternalApp(JSON.stringify(TPA));
                    /**
                     * Visibility de AAF a false, porque se lanza la app externa
                     */
                    if(res && isTpaKeyUp(TPA)) {
                        setAAFTPAState(TPA_WAS_FIRED);
                    }

                    if(successCallBack && Utils.isFunction(successCallBack)) {
                        logger.debug('[TPACBK] ThirdPartyEpgHelper::fireTPA se lanza callback de launch con res: ', res);
                        successCallBack(TPA, playerOptions, res);
                    }
                }
            }, fireTPA_timeout_milliseconds);
        };

        const isThirdPartyApp = function(gid) {
            let isTPA = false;

            // console.log('[TPA] ThirdPartyEpgHelper::isThirdPartyApp enter');
            // console.log('[TPA] ThirdPartyEpgHelper::isThirdPartyApp gid: ', gid);
            // console.log('[TPA] ThirdPartyEpgHelper::isThirdPartyApp thirdPartyapps: ', thirdPartyapps);
            // Ya está cacheado
            if(thirdPartyapps.has(parseInt(gid))) {
                isTPA = true;

                return isTPA;
            }

            let channelLiveUrl = Utils.getChannelLiveUrl(gid);
            if (channelLiveUrl) {
                const apaKey = getApaKey();
                if (Utils.isNotNullOrNotUndefined(apaKey[channelLiveUrl])) {
                    // Cache gid
                    thirdPartyapps.add(parseInt(gid));
                    // console.log('[TPA] ThirdPartyEpgHelper::isThirdPartyApp return true');
                   isTPA = true;
                }
            }
            // console.log('[TPA] ThirdPartyEpgHelper::isThirdPartyApp return ', isTPA);

            return isTPA;
        };

        const getTPAType = (TPA = {}) => {
            let TPAType = '';
            if (TPA && (typeof TPA === 'object') && TPA.package && (typeof TPA.package === 'string') ) {
                if (TPA.package.includes('netflix')) {
                TPAType = 'netflix';
                }
                if (TPA.package.includes('amazon')) {
                TPAType = 'amazon';
                }
            }
            return TPAType;
        };

        const getTPANotice = (TPAType = '') => {
            const labelPress = Translator.get("externalAplication_alert_title_label_press", "Presiona");
            const labelOk = Translator.get("externalAplication_alert_title_label_OK", "OK");
            const labelAccess = Translator.get("externalAplication_alert_title_label_access", "para entrar a");
            const labelApp = Translator.get(`externalAplication_alert_title_label_${TPAType}`, TPAType);
            return `${labelPress} <strong>${labelOk}</strong> ${labelAccess} <strong>${labelApp}</strong>`;
        };

        const getTPABackground = (TPAType = '') => {
            const region = DeviceStorage.getItem('region');
            const TPABackground = Asset.get(`externalAplication_alert_${TPAType}_background_${region}`, `externalAplication_alert_${TPAType}_background`);
            return TPABackground;
        };

        const getThirdPartyApp = function (nextOptions, nextContentType = null) {
            // console.log('[TPA] ThirdPartyEpgHelper::getThirdPartyApp enter');
            let TPA = null;

            if (!nextContentType) {
                nextContentType = PlayerHelper.getContentType(nextOptions);
            }

            if (nextContentType === AAF_CONTENT_IS_TV) {
                // Si es TV, recuperar el live_url
                if (nextOptions.source && nextOptions.source.videoid) {
                    // const channelLiveUrl = 'urn://com.netflix.ninja';
                    let channelLiveUrl = Utils.getChannelLiveUrl(nextOptions.source.videoid);
                    // console.log('[TPA] ThirdPartyEpgHelper::getThirdPartyApp groupId: ', nextOptions.source.videoid, ' | liveUrl: ', channelLiveUrl);

                    if (channelLiveUrl) {
                        const playLiveFrom = Utils.isNotNullOrNotUndefined(nextOptions.playLiveFrom) ? nextOptions.playLiveFrom : LIVE_PLAY_FROM_EPG;
                        // console.log('[TPA] ThirdPartyEpgHelper::getThirdPartyApp nextOptions.playLiveFrom: ' + (nextOptions.playLiveFrom ? nextOptions.playLiveFrom : 'VACIO'));
                        TPA = ThirdPartyEpgHelper.getTPA(channelLiveUrl, playLiveFrom);
                        if (TPA && (typeof TPA === 'object')) {
                            const TPAType = getTPAType(TPA);
                            const TPANotice = getTPANotice(TPAType);
                            const TPABackground = getTPABackground(TPAType);
                            const newProps = { type: TPAType, notice: TPANotice, background: TPABackground };
                            TPA = { ...TPA, ...newProps };
                        }
                    }
                }
            }
            else {
                // console.log('[TPA] ThirdPartyEpgHelper::getThirdPartyApp nada que hacer, no es TV content');
            }

            return TPA;
        };

        const fireTV = function() {
            const lastGid = TvChannelUtil.getLastChannel();
            if(isNaN(lastGid)) return;

            setTimeout(function() {
                const params = {
                    playerstate: 'PLAYING',
                    source: {
                      videoid: lastGid
                    },
                    size: {
                      top: 0,
                      left: 0,
                      width: 1280,
                      height: 720
                    },
                    ispreview: false,
                    islive: true,
                    ispip: false
                  };

                  store.dispatch(playFullMedia(params));

            }, fireTV_timeout_milliseconds);
        };

        return {
            getApaKey,
            getTPA,
            fireTPA,
            getThirdPartyApp,
            isThirdPartyApp,
            setAAFTPAState,
            getAAFTPAState,
            fireTV
        };
    }
)();



// WEBPACK FOOTER //
// ./src/AAFPlayer/helpers/ThirdPartyEpgHelper.js